/**
* How It Works JS
* -----------------------------------------------------------------------------
*
* All the JS for the How It Works component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'how-it-works',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      // if ( window.matchMedia( '(min-width : 1024px)' ).matches ) {
      //   const tl = gsap.timeline( {
      //     scrollTrigger: {
      //       trigger: '.how-it-works',
      //       start: 'top top+=69px',
      //       end: 'bottom bottom',
      //       scrub: 1,
      //       markers: true,
      //     },
      //   } );
      //   tl.to( '.how-it-works__image-wrapper ', {yPercent: 100, duration: 1} );
      // }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'how-it-works', COMPONENT );
} )( app );
